import { portalApi, TAGS } from "../../../api/rtkApi";

import type { UUID } from "../../../utils/uuid";
import type { SettlementPreferences } from "../models/SettlementPreferences";

type GetSettlementPreferencesResponse = SettlementPreferences;

type GetSettlementPreferencesQuery = {
  customerId?: UUID;
};

type UpdateSettlementPreferencesResponse = SettlementPreferences;

type UpdateSettlementPreferencesQuery = {
  customerId: UUID;
  settlementPreferences: SettlementPreferences;
};

const extendedApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettlementPreferences: builder.query<
      GetSettlementPreferencesResponse,
      GetSettlementPreferencesQuery
    >({
      query: ({ customerId }) =>
        `customers/${customerId}/countries/BR/settlement-preferences`,
      providesTags: (result, error, { customerId }) => [
        { type: TAGS.SETTLEMENT_PREFERENCES, customerId },
      ],
    }),
    updateSettlementPreferences: builder.mutation<
      UpdateSettlementPreferencesResponse,
      UpdateSettlementPreferencesQuery
    >({
      query: ({ customerId, settlementPreferences }) => ({
        url: `customers/${customerId}/countries/BR/settlement-preferences`,
        method: "PUT",
        body: settlementPreferences,
      }),
      async onQueryStarted(
        { customerId, settlementPreferences },
        { dispatch, queryFulfilled }
      ) {
        try {
          await queryFulfilled;
          dispatch(
            extendedApi.util.updateQueryData(
              "getSettlementPreferences",
              { customerId },
              (draft: SettlementPreferences) => {
                Object.assign(draft, settlementPreferences);
              }
            )
          );
        } catch {}
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSettlementPreferencesQuery,
  useUpdateSettlementPreferencesMutation,
} = extendedApi;
